export default __webpack_public_path__ + "static/media/App.css.0dfa1308.txt";